import React, { useMemo } from 'react';
import moment from 'moment';
import { keyBy } from 'lodash';

import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { PanelHeader } from 'js/components';

import styles from 'js/engines/SurveyAssessment/components/Review/QuestionDetail/LongTextQuestionDetail.module.scss';

const LongTextQuestionDetail = ({ assessment, question, team, match }) => {
  const userLocale =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;

  const { responses = [] } = question;
  const participantsById = useMemo(
    () => keyBy(assessment?.participants ?? [], 'id'),
    [assessment?.participants]
  );

  const sortedResponses = useMemo(
    () =>
      [...responses].sort(
        (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
      ),
    [responses]
  );

  const resultsHref = match.url.replace(/\/questions\/[^/]+$/, '/results');

  return (
    <div className="question-set-history live-assessment-review-detail">
      <PanelHeader size="flex">
        <div className="panel-content assessment-review-header">
          <section className="details">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <label>Assessment</label>
                  <h1>{assessment.name}</h1>
                  <div className="timestamp">
                    {moment(assessment.inserted_at).format(
                      'MMM D, YYYY h:mm a'
                    )}
                  </div>
                  <label>Team</label>
                  <h2>{team?.name}</h2>
                  <label>Question</label>
                  <div className="lead">{question.text}</div>
                  <Link to={resultsHref} className="info">
                    Back to results
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </PanelHeader>
      <div className="content">
        {sortedResponses.map((r) => {
          const date = new Date(r.updated_at);
          const participant = participantsById[r.participant_id];
          const name = participant?.name?.trim();

          return (
            <article key={r.id}>
              <label className={styles.label}>
                {[
                  name,
                  `${date.toLocaleDateString(userLocale, {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })}, ${date.toLocaleTimeString(userLocale)}`,
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </label>

              <Card>
                <CardBody>
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    {(r.value ?? '').trim()}
                  </div>
                </CardBody>
              </Card>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default LongTextQuestionDetail;
